import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'antd'
import { translate } from 'react-i18next'
import { routersHelper } from './Routers'
import { useDispatch, useSelector } from 'react-redux'
import { CANCEL_MEMBER_SHIP } from './../redux/actions/type'
import { checkTokenExpire } from './../redux/actions/actions'
import { isNull } from 'lodash'
import analytics from '../libs/analytics'

const PopupCancelMemberShip = ({ t, visible, setVisible, dueDate }) => {
    const language = localStorage.getItem('i18nextLng')
    const { useRouter } = routersHelper
    const router = useRouter()
    const dispatch = useDispatch()
    const storeMemberShip = useSelector(state => state.cancelMemberShip)
    const [submit, setsubmit] = useState(false)

    const hanndleChange = () => {
        analytics.sendEvent({
            category: 'Plan & Pricing',
            action: 'PlanAndPricing-CancelMember-Button-Clicked',
        });
        setVisible(false)
        dispatch(checkTokenExpire)
        dispatch({
            type: CANCEL_MEMBER_SHIP,
        })
        setsubmit(true)
    }

    const handleCancel = () => {

        setVisible(false)
    };

    useEffect(() => {
        if (submit && !isNull(storeMemberShip.status)) {
            if (storeMemberShip.status === 200) {
                analytics.sendEvent({
                    category: 'Plan & Pricing',
                    action: 'PlanAndPricing-Cancel-ReDirect-Success',
                });
                router.push(`/portal/successmembership`)
            } else {
                router.push(`/portal/errormembership`)
            }
        }
    }, [submit, storeMemberShip, router])

    return (
        <Modal
            visible={visible}
            closable={false}
            onCancel={handleCancel}
            footer={
                [
                    <Button form="modal-reservation-form" key="submit" className="btn-submit-cancel-membership" onClick={() => setVisible(false)}>
                        {t("modal_cancel_membership.ok")}
                    </Button>,
                    <Button onClick={hanndleChange} key="back" type="text" className="btn-cancel-membership">
                        {t("modal_cancel_membership.cancel")}
                    </Button>
                ]
            }
            className="popup-membership"
        >
            <div>
                <div className="title-cancel-membership">{t("modal_cancel_membership.title")}</div>
                <div className="detail-canccel-membershiip">
                    {t("modal_cancel_membership.detail")} {dueDate}{language === 'en' ? '.' : null}
                </div>
            </div>
        </Modal>
    )
}

export default translate()(PopupCancelMemberShip)
